import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p431127638481854464',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
